<svg class="svg-wrapper" [attr.width]="size()" [attr.height]="size()">
  <use class="svg-use" [attr.xlink:href]="svgName()" />
</svg>
